document.addEventListener("DOMContentLoaded", () => {
  const promoBanner = document.querySelector(".promo-banner");
  const modal = document.getElementById("promoModal");
  const closeButton = document.querySelector(
    '[data-i18n="prices.modal.form.cancel"]'
  );

  // Add error checking
  if (!promoBanner) {
    console.error("Promo button not found");
    return;
  }

  if (!modal) {
    console.error("Promo modal not found");
    return;
  }

  function openPromoModal() {
    modal.showModal();
  }

  function closePromoModal() {
    modal.close();
  }

  // Close modal when clicking outside
  modal.addEventListener("click", (e) => {
    const modalDimensions = modal.getBoundingClientRect();
    if (
      e.clientX < modalDimensions.left ||
      e.clientX > modalDimensions.right ||
      e.clientY < modalDimensions.top ||
      e.clientY > modalDimensions.bottom
    ) {
      closePromoModal();
    }
  });

  promoBanner.addEventListener("click", openPromoModal);
  closeButton.addEventListener("click", closePromoModal);
});
